/*
 * -----------------------------------------------------------------------------------------
 * index.tsx
 *
 * Copyright: (c) 2004-2020 Potthoff + Partner Unternehmensberatungs-Gesellschaft mbH
 *            All rights reserved.
 * -----------------------------------------------------------------------------------------
 * Erstellt : 12.10.2020
 * Autor    : Markus Plutka
 *
 * Geändert : 14.02.2023
 *      von : Jonas Wessel
 * -----------------------------------------------------------------------------------------
 *
 * Changelog:
 *
 */

import Loading from "components/Loading/Loading";
import "@kos-frontend/react-lib/styles/minimal.scss";
import { retryLoad } from "@kos-frontend/react-lib/utils/react";
import React, { Suspense } from "react";
//import { render } from "react-dom";
import * as ReactDOMClient from 'react-dom/client';
import { Provider } from "react-redux";
import ErrorBoundary from "screens/ErrorBoundary/ErrorBoundary";
import initStore from "./store";
import {HashRouter} from "react-router-dom";

const App = React.lazy(() => retryLoad(() =>import("screens/App/App")));

// TODO MFP: Formatieren bzw. Icon verwenden

let appRoot: HTMLElement | null = null;
if (!document.querySelector("#page-wrapper")) {
    appRoot = document.createElement("div");
    appRoot.setAttribute("id", "page-wrapper");
    document.body.appendChild(appRoot);
} else {
    appRoot = document.getElementById("page-wrapper");
}

const root = ReactDOMClient.createRoot(appRoot as HTMLElement);

initStore(async(store) => {
    const renderApp = (store) => {
        root.render(
                <Provider store={store}>
                    <ErrorBoundary>
                        <Suspense fallback={<Loading/>}>
                            <HashRouter>
                                <App />
                            </HashRouter>
                        </Suspense>
                    </ErrorBoundary>
                </Provider>
            //appRoot
        );
    };
    if((module as any).hot){
        (module as any).hot.accept("screens/App/App", renderApp);
    }
    renderApp(store);
});
